import React from 'react';
import { useHelp } from './HelpContext';

/**
 * Header button that toggles the help panel.
 * Drop into any toolbar — it reads state from HelpContext.
 */
const HelpTrigger: React.FC = () => {
  const { toggle, state } = useHelp();

  return (
    <button
      className="liquid-glass-header__theme-toggle"
      onClick={toggle}
      title="Help (?)"
      aria-label="Toggle help panel"
      style={{ position: 'relative' }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={state.isOpen ? '#14B8A6' : 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    </button>
  );
};

export default HelpTrigger;
